import React, { useEffect, useMemo, useState } from 'react';
import { useStoreState } from 'state/hooks/store.state.hook';
import { EBundlesInternalViewModel } from 'utils/enums';
import { PlayerLevel } from 'utils/types';
import { mapPlayerLevelViewModel } from '../../utils';
import { ProductMadnessPlayerLevel } from './ProductMadness';
import { StyledPlayerLevelsWrapper } from './style';

export interface IPlayerLevelWrapperProps {
  hasOffers: boolean;
  playerLevels?: PlayerLevel[];
  playerLevelImage?: string;
  refetchOffers: () => void;
}

export const PlayerLevelWrapper: React.FC<IPlayerLevelWrapperProps> = ({
  hasOffers,
  playerLevels,
  playerLevelImage,
  refetchOffers,
}) => {
  const { storeTheme } = useStoreState();

  const [playerLevelsData, setPlayerLevelsData] = useState<
    PlayerLevel[] | null
  >(null);

  const { bundlesInternalViewModel } = storeTheme!.general;

  useEffect(() => {
    if (!hasOffers || !playerLevels) return;

    setPlayerLevelsData(playerLevels);
  }, [hasOffers, playerLevels]);

  const isProductMadness = useMemo(
    () =>
      bundlesInternalViewModel === EBundlesInternalViewModel.JACKPOT_SLOTS ||
      bundlesInternalViewModel === EBundlesInternalViewModel.BIG_FISH_CASINO,
    [bundlesInternalViewModel],
  );

  const PlayerLevelComponent = useMemo(
    () => mapPlayerLevelViewModel[bundlesInternalViewModel],
    [bundlesInternalViewModel],
  );

  if (isProductMadness)
    return <ProductMadnessPlayerLevel playerLevelImage={playerLevelImage} />;

  if (!playerLevelsData || playerLevelsData?.length === 0) return <></>;

  if (!PlayerLevelComponent) {
    console.log('No player level template exists');
    return <></>;
  }

  return (
    <StyledPlayerLevelsWrapper className={'player-level-wrapper'}>
      {playerLevelsData.map((playerLevelData: PlayerLevel) => (
        <PlayerLevelComponent
          {...playerLevelData}
          onTimerDoneHandler={refetchOffers}
        />
      ))}
    </StyledPlayerLevelsWrapper>
  );
};
